export default {
    topics: [
        {
            title: ' ApplyDuplicateRules ',
            href: 'sm-session-ApplyDuplicateRules.html',
            attributes: { 'data-id': 'sm-session-ApplyDuplicateRules' },
            menu: { hasChildren: false },
            tocID: 'sm-session-ApplyDuplicateRules-d66e1325',
            topics: [],
        },
        {
            title: ' BearerTokenLogon ',
            href: 'sm-session-BearerTokenLogon.html',
            attributes: { 'data-id': 'sm-session-BearerTokenLogon' },
            menu: { hasChildren: false },
            tocID: 'sm-session-BearerTokenLogon-d66e1333',
            topics: [],
        },
        {
            title: ' ChangePassword ',
            href: 'sm-session-ChangePassword.html',
            attributes: { 'data-id': 'sm-session-ChangePassword' },
            menu: { hasChildren: false },
            tocID: 'sm-session-ChangePassword-d66e1341',
            topics: [],
        },
        {
            title: ' DeleteCollection ',
            href: 'sm-session-DeleteCollection.html',
            attributes: { 'data-id': 'sm-session-DeleteCollection' },
            menu: { hasChildren: false },
            tocID: 'sm-session-DeleteCollection-d66e1349',
            topics: [],
        },
        {
            title: ' Diff ',
            href: 'sm-session-Diff.html',
            attributes: { 'data-id': 'sm-session-Diff' },
            menu: { hasChildren: false },
            tocID: 'sm-session-Diff-d66e1357',
            topics: [],
        },
        {
            title: ' Duplicate ',
            href: 'sm-session-Duplicate.html',
            attributes: { 'data-id': 'sm-session-Duplicate' },
            menu: { hasChildren: false },
            tocID: 'sm-session-Duplicate-d66e1365',
            topics: [],
        },
        {
            title: ' DuplicateTo ',
            href: 'sm-session-DuplicateTo.html',
            attributes: { 'data-id': 'sm-session-DuplicateTo' },
            menu: { hasChildren: false },
            tocID: 'sm-session-DuplicateTo-d66e1373',
            topics: [],
        },
        {
            title: ' DuplicateWithMappingId ',
            href: 'sm-session-DuplicateWithMappingId.html',
            attributes: { 'data-id': 'sm-session-DuplicateWithMappingId' },
            menu: { hasChildren: false },
            tocID: 'sm-session-DuplicateWithMappingId-d66e1381',
            topics: [],
        },
        {
            title: ' Encrypt ',
            href: 'sm-session-Encrypt.html',
            attributes: { 'data-id': 'sm-session-Encrypt' },
            menu: { hasChildren: false },
            tocID: 'sm-session-Encrypt-d66e1389',
            topics: [],
        },
        {
            title: ' EncryptServerPassword ',
            href: 'sm-session-EncryptServerPassword.html',
            attributes: { 'data-id': 'sm-session-EncryptServerPassword' },
            menu: { hasChildren: false },
            tocID: 'sm-session-EncryptServerPassword-d66e1397',
            topics: [],
        },
        {
            title: ' FormatDataPolicy ',
            href: 'sm-session-FormatDataPolicy.html',
            attributes: { 'data-id': 'sm-session-FormatDataPolicy' },
            menu: { hasChildren: false },
            tocID: 'sm-session-FormatDataPolicy-d66e1406',
            topics: [],
        },
        {
            title: ' GetActiveApplicationMenus ',
            href: 'sm-session-GetActiveApplicationMenus.html',
            attributes: { 'data-id': 'sm-session-GetActiveApplicationMenus' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetActiveApplicationMenus-d66e1414',
            topics: [],
        },
        {
            title: ' GetCnxInfo ',
            href: 'sm-session-GetCnxInfo.html',
            attributes: { 'data-id': 'sm-session-GetCnxInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetCnxInfo-d66e1422',
            topics: [],
        },
        {
            title: ' GetDefaultEntity ',
            href: 'sm-session-GetDefaultEntity.html',
            attributes: { 'data-id': 'sm-session-GetDefaultEntity' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetDefaultEntity-d66e1430',
            topics: [],
        },
        {
            title: ' GetDirtyCacheEntities ',
            href: 'sm-session-GetDirtyCacheEntities.html',
            attributes: { 'data-id': 'sm-session-GetDirtyCacheEntities' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetDirtyCacheEntities-d66e1438',
            topics: [],
        },
        {
            title: ' GetEntityIfMoreRecent ',
            href: 'sm-session-GetEntityIfMoreRecent.html',
            attributes: { 'data-id': 'sm-session-GetEntityIfMoreRecent' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetEntityIfMoreRecent-d66e1446',
            topics: [],
        },
        {
            title: ' GetImages ',
            href: 'sm-session-GetImages.html',
            attributes: { 'data-id': 'sm-session-GetImages' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetImages-d66e1454',
            topics: [],
        },
        {
            title: ' GetNewIds ',
            href: 'sm-session-GetNewIds.html',
            attributes: { 'data-id': 'sm-session-GetNewIds' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetNewIds-d66e1462',
            topics: [],
        },
        {
            title: ' GetNewIdsEx ',
            href: 'sm-session-GetNewIdsEx.html',
            attributes: { 'data-id': 'sm-session-GetNewIdsEx' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetNewIdsEx-d66e1470',
            topics: [],
        },
        {
            title: ' GetOption ',
            href: 'sm-session-GetOption.html',
            attributes: { 'data-id': 'sm-session-GetOption' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetOption-d66e1478',
            topics: [],
        },
        {
            title: ' GetPkList ',
            href: 'sm-session-GetPkList.html',
            attributes: { 'data-id': 'sm-session-GetPkList' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetPkList-d66e1486',
            topics: [],
        },
        {
            title: ' GetServerTime ',
            href: 'sm-session-GetServerTime.html',
            attributes: { 'data-id': 'sm-session-GetServerTime' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetServerTime-d66e1495',
            topics: [],
        },
        {
            title: ' GetUserInfo ',
            href: 'sm-session-GetUserInfo.html',
            attributes: { 'data-id': 'sm-session-GetUserInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-session-GetUserInfo-d66e1503',
            topics: [],
        },
        {
            title: ' HashPassword ',
            href: 'sm-session-HashPassword.html',
            attributes: { 'data-id': 'sm-session-HashPassword' },
            menu: { hasChildren: false },
            tocID: 'sm-session-HashPassword-d66e1511',
            topics: [],
        },
        {
            title: ' ImportCollection ',
            href: 'sm-session-ImportCollection.html',
            attributes: { 'data-id': 'sm-session-ImportCollection' },
            menu: { hasChildren: false },
            tocID: 'sm-session-ImportCollection-d66e1519',
            topics: [],
        },
        {
            title: ' KillSession ',
            href: 'sm-session-KillSession.html',
            attributes: { 'data-id': 'sm-session-KillSession' },
            menu: { hasChildren: false },
            tocID: 'sm-session-KillSession-d66e1527',
            topics: [],
        },
        {
            title: ' Load ',
            href: 'sm-session-Load.html',
            attributes: { 'data-id': 'sm-session-Load' },
            menu: { hasChildren: false },
            tocID: 'sm-session-Load-d66e1535',
            topics: [],
        },
        {
            title: ' LoadAsText ',
            href: 'sm-session-LoadAsText.html',
            attributes: { 'data-id': 'sm-session-LoadAsText' },
            menu: { hasChildren: false },
            tocID: 'sm-session-LoadAsText-d66e1543',
            topics: [],
        },
        {
            title: ' LoadIfExists ',
            href: 'sm-session-LoadIfExists.html',
            attributes: { 'data-id': 'sm-session-LoadIfExists' },
            menu: { hasChildren: false },
            tocID: 'sm-session-LoadIfExists-d66e1551',
            topics: [],
        },
        {
            title: ' Logoff ',
            href: 'sm-session-Logoff.html',
            attributes: { 'data-id': 'sm-session-Logoff' },
            menu: { hasChildren: false },
            tocID: 'sm-session-Logoff-d66e1559',
            topics: [],
        },
        {
            title: ' Logon ',
            href: 'sm-session-Logon.html',
            attributes: { 'data-id': 'sm-session-Logon' },
            menu: { hasChildren: false },
            tocID: 'sm-session-Logon-d66e1567',
            topics: [],
        },
        {
            title: ' NewInstance ',
            href: 'sm-session-NewInstance.html',
            attributes: { 'data-id': 'sm-session-NewInstance' },
            menu: { hasChildren: false },
            tocID: 'sm-session-NewInstance-d66e1575',
            topics: [],
        },
        {
            title: ' Remove ',
            href: 'sm-session-Remove.html',
            attributes: { 'data-id': 'sm-session-Remove' },
            menu: { hasChildren: false },
            tocID: 'sm-session-Remove-d66e1584',
            topics: [],
        },
        {
            title: ' ServerShutdown ',
            href: 'sm-session-ServerShutdown.html',
            attributes: { 'data-id': 'sm-session-ServerShutdown' },
            menu: { hasChildren: false },
            tocID: 'sm-session-ServerShutdown-d66e1592',
            topics: [],
        },
        {
            title: ' SetDefaultValues ',
            href: 'sm-session-SetDefaultValues.html',
            attributes: { 'data-id': 'sm-session-SetDefaultValues' },
            menu: { hasChildren: false },
            tocID: 'sm-session-SetDefaultValues-d66e1600',
            topics: [],
        },
        {
            title: ' SetDefaults ',
            href: 'sm-session-SetDefaults.html',
            attributes: { 'data-id': 'sm-session-SetDefaults' },
            menu: { hasChildren: false },
            tocID: 'sm-session-SetDefaults-d66e1608',
            topics: [],
        },
        {
            title: ' TestCnx ',
            href: 'sm-session-TestCnx.html',
            attributes: { 'data-id': 'sm-session-TestCnx' },
            menu: { hasChildren: false },
            tocID: 'sm-session-TestCnx-d66e1616',
            topics: [],
        },
        {
            title: ' Write ',
            href: 'sm-session-Write.html',
            attributes: { 'data-id': 'sm-session-Write' },
            menu: { hasChildren: false },
            tocID: 'sm-session-Write-d66e1624',
            topics: [],
        },
        {
            title: ' WriteCollection ',
            href: 'sm-session-WriteCollection.html',
            attributes: { 'data-id': 'sm-session-WriteCollection' },
            menu: { hasChildren: false },
            tocID: 'sm-session-WriteCollection-d66e1632',
            topics: [],
        },
    ],
};

